import { useState } from 'react';
import { AiOutlinePrinter } from 'react-icons/ai';
import { FiFileText } from 'react-icons/fi';
import { useParams } from 'react-router';

import { DataTable, StyledButton } from '../../../../../components';
import { useOrdemRepasseBaixa } from '../../../../../services/hooks/useOrdemRepasseBaixa';
import { PrintComponent } from '../../../../../services/PrintComponent';
import { AdminTitle } from '../../../components';
import { Container, FiltersContainer } from './styles';

const tableHead = [
  'Data',
  'Item',
  'Valor de Locação',
  'Valor de Desconto',
  'Valor Pago',
  'Taxa de Administração',
  'Taxa de Antecipação',
];

export const Baixas = () => {
  const { id } = useParams();

  const { data, isLoading, isFetching, error } = useOrdemRepasseBaixa(id);

  const [print, setPrint] = useState(false);

  return (
    <Container>
      <AdminTitle title="Baixas" icon={<FiFileText />} />
      <h3>Consulte aqui suas movimentações</h3>

      <FiltersContainer>
        <StyledButton
          text="Imprimir"
          icon={<AiOutlinePrinter />}
          iconPosition="right"
          onClick={() => setPrint(true)}
          disabled={isLoading || isFetching}
        />
      </FiltersContainer>

      <PrintComponent onPrint={print} setOnPrint={setPrint}>
        <DataTable title="Detalhado" heads={tableHead} hasPagination={false}>
          {isLoading || isFetching ? (
            <tbody>
              <tr>
                <td colSpan={7}>Carregando...</td>
              </tr>
            </tbody>
          ) : error ? (
            <tbody>
              <tr>
                <td colSpan={7}>Falha ao obter dados</td>
              </tr>
            </tbody>
          ) : data?.length === 0 ? (
            <tbody>
              <tr>
                <td colSpan={11}>Não foram encontrados dados</td>
              </tr>
            </tbody>
          ) : (
            <tbody>
              {data?.map((pagamento) => (
                <tr>
                  <td>
                    {new Date(pagamento.dtBaixa)?.toLocaleDateString('pt-BR')}
                  </td>
                  <td>{pagamento.item}</td>
                  <td>
                    {pagamento.vlLocacao.toLocaleString('pt-BR', {
                      style: 'currency',
                      currency: 'BRL',
                      minimumFractionDigits: 2,
                    })}
                  </td>
                  <td>
                    {pagamento.vlOutrosDesc.toLocaleString('pt-BR', {
                      style: 'currency',
                      currency: 'BRL',
                      minimumFractionDigits: 2,
                    })}
                  </td>
                  <td>
                    {pagamento.vlPgto.toLocaleString('pt-BR', {
                      style: 'currency',
                      currency: 'BRL',
                      minimumFractionDigits: 2,
                    })}
                  </td>
                  <td>
                    {pagamento.vlTxAdm.toLocaleString('pt-BR', {
                      style: 'currency',
                      currency: 'BRL',
                      minimumFractionDigits: 2,
                    })}
                  </td>
                  <td>
                    {pagamento.vlTxAnt.toLocaleString('pt-BR', {
                      style: 'currency',
                      currency: 'BRL',
                      minimumFractionDigits: 2,
                    })}
                  </td>
                </tr>
              ))}
            </tbody>
          )}
        </DataTable>
      </PrintComponent>
    </Container>
  );
};
